import React from "react";
import { Link } from "react-router-dom";

import { ArrowCircleLeft } from "iconsax-react";

const BotaoVoltar = ({ to }) => (
    <Link className="botao-voltar2" to={to}>
        <ArrowCircleLeft size="32" />
    </Link>
);

export default BotaoVoltar;
